const initEventForm = (form) => {
    const placePicker = form.querySelector('.js-place-picker');
    const newPlaceFields = form.querySelectorAll('.js-add-place');
    const deleteOverlayTriggers = form.querySelectorAll('.js-overlay-trigger');
    const deleteOverlay = document.querySelector('.js-delete-overlay');
    // Handle functions

    const handleAddEvent = (dropdownValue) => {
        if (dropdownValue == 'add-new-place') {
            newPlaceFields.forEach((field) => {
                field.classList.remove('hidden');
            });
        } else {
            newPlaceFields.forEach((field) => {
                field.classList.add('hidden');
                field.value = '';
            });
        }
    };

    const handleOverlay = () => {
        deleteOverlay.classList.toggle('is-active');
    };

    // Event listeners

    if (placePicker) {
        placePicker.addEventListener('change', (e) => {
            handleAddEvent(e.target.value);
        });

        window.addEventListener('DOMContentLoaded', () => {
            handleAddEvent(placePicker.value);
        });
    }

    deleteOverlayTriggers.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            handleOverlay();
        });
    });

    // Form validation helpers
    const showError = (input) => {
        const errorEl = input.closest('.custom-form__group').querySelector('.custom-form__error');
        if (errorEl) {
            errorEl.classList.add('is-active');
        }
        input.setAttribute('aria-invalid', 'true');
        window.scrollTo({ top: input.getBoundingClientRect().top + window.scrollY - 200});
    };

    const hideError = (input) => {
        const errorEl = input.closest('.custom-form__group').querySelector('.custom-form__error');
        if (errorEl) {
            errorEl.classList.remove('is-active');
        }
        input.removeAttribute('aria-invalid');
    };

    document.addEventListener('DOMContentLoaded', () => {
        const form = document.querySelector('.js-event-form');
        if (!form) return;

        // Hide all error messages on start
        const errors = form.querySelectorAll('.custom-form__error');
        errors.forEach(error => error.classList.remove('is-active'));

        form.addEventListener('submit', (e) => {
            let valid = true;

            // Validate all required fields
            const requiredFields = form.querySelectorAll('[required]');
            requiredFields.forEach((field) => {
                if (!field.value.trim()) {
                    showError(field);
                    valid = false;
                } else {
                    hideError(field);
                }
            });

            // Email validation (if filled in)
            const email = form.querySelector('#email');
            if (email && email.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
                showError(email);
                valid = false;
            } else if (email) {
                hideError(email);
            }

            if (!valid) {
                e.preventDefault(); // Stop form submission
            }
        });

        // Instant error revalidation
        form.querySelectorAll('input, textarea, select').forEach(field => {
            field.addEventListener('input', () => hideError(field));
            field.addEventListener('change', () => hideError(field));
        });
});

}

export default initEventForm;